import React, {useEffect, useState} from 'react';
import { useAuth } from '../../context/auth'
import { useMessage } from '../../context/message'
import Grid from '@material-ui/core/Grid'
import MaterialTable from 'material-table'
import CustomFilter from '../CustomFilter';
import LaunchIcon from '@material-ui/icons/Launch'

export default function AdminMessages({id, setId}){
  const [data, setData] = useState([])
  const {auth} = useAuth()
  const { setMessage } = useMessage()

  useEffect(() => {
    fetch(`/api/message/admin`, {
      method: 'GET',
      headers: {
        'x-access-token': sessionStorage.getItem('token')
      }
    })
    .then(response => auth(response))
    .then((response) => {
      setData(response.data)
    })
    .catch((error) => {
      setMessage({'type': 'error', 'text': 'Error! Unable to fetch messages'})
      console.error('Error:', error)
    })
  }, [])

  const columns = [
    {
      title: 'Conversation Id',
      field: 'conversation_id'
    },
    {
      title: 'Conversation Title',
      field: 'conversation_title'
    },
    {
      title: 'Message Id',
      field: 'message_id'
    },
    {
      title: 'Sent By',
      field: 'sent_by'
    },
    {
      title: 'Sent To',
      field: 'sent_to'
    },
    {
      title: 'Message',
      field: 'message'
    },
    {
      title: 'Created',
      field: 'created'
    }

  ]

  return(
    <MaterialTable
      title = 'All Messages'
      columns = {columns}
      data = {data}
      options = {{
        filtering : true,
        draggable : false
      }}
      actions = {[
        {
          icon: () => <LaunchIcon/>,
          tooltip: 'View Conversation',
          onClick: (event, rowData) => setId(rowData.conversation_id)
        },
      ]}
      components={{
        FilterRow: props => <CustomFilter {...props} />,
      }}
    />
  )
}
